export default __webpack_public_path__ + "static/media/user_avatar.79d39416.jpg";